<div class="delegation-empty-card flex-col justify-center items-center gap-10">
    <div class="delegation-empty-card-icon justify-center items-center">
        <mat-icon svgIcon="delegate"></mat-icon>
    </div>
    <div class="delegation-empty-card-message">You have no delegations assigned to you</div>
</div>
